/**
 * AnnouncementCategoryService
 * Service for managing announcement categories
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for announcement category CRUD operations
 */
export class AnnouncementCategoryService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AnnouncementCategoryService.DEFAULT_SERVICE_PATH,
            basePath: AnnouncementCategoryService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
AnnouncementCategoryService.DEFAULT_SERVICE_PATH = 'announcements';
AnnouncementCategoryService.BASE_PATH = 'api/announcement-categories';
//# sourceMappingURL=AnnouncementCategoryService.js.map